import React from 'react';
import Settings from '../components/Settings';

const SettingsPage: React.FC = () => {
  return (
    <div className="h-screen overflow-hidden">
      <Settings isOpen={true} onClose={() => window.history.back()} />
    </div>
  );
};

export default SettingsPage;
